import { gql } from "@apollo/client";

const GET_NOTIFICATIONS = gql`
  query notifications($params: QueryParams, $title: String) {
    notifications(params: $params, title: $title) {
      results {
        id
        title
        description
        scheduledDate
        createdAt
      }
    }
  }
`;

export { GET_NOTIFICATIONS };
